import { createFileRoute } from '@tanstack/react-router';

import { LandDetailPage } from '@/features/land/land-detail-page';

export const Route = createFileRoute('/_app/land/$listingId')({ component: RouteComponent });

function RouteComponent() {
  const { listingId } = Route.useParams();
  return <LandDetailPage listingId={listingId} />;
}
